import { createSlice } from '@reduxjs/toolkit';

export const canvasCssIsLoadingSlice = createSlice({
	name: 'canvasCssIsLoading',
	initialState: {
		value: true,
	},
	reducers: {
		setCssIsLoading: (state, action) => {
			state.value = action.payload;
		},
	},
});

// Action creators are generated for each case reducer function
export const { setCssIsLoading } = canvasCssIsLoadingSlice.actions;
export const cssIsLoading = (state) => state.canvasCssIsLoading.value;
export default canvasCssIsLoadingSlice.reducer;
